export const editIncidencesInitialState = {
	incidences: null,
	error: null,
	errorShow: false,
	loading: false,
};
